query teachers($teamId: ID!) {
  teachers(teamId: $teamId) {
    id
    first
    last
    email
    user {
      id
    }
    teacherPhoneNumbers {
      id
      formattedNumber
    }
  }
}
